const normalizeSearchText = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const searchableText = (item) => normalizeSearchText([
  item.label,
  item.detail,
  item.category,
  ...(item.keywords || []),
].join(' '));

const matchRank = (item, normalizedQuery, queryWords) => {
  const label = normalizeSearchText(item.label);
  if (label.startsWith(normalizedQuery)) return 0;
  if (label.includes(normalizedQuery)) return 1;

  const haystack = searchableText(item);
  return queryWords.every((word) => haystack.includes(word)) ? 2 : -1;
};

export const searchAddContentItems = (items, query) => {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return [];

  const queryWords = normalizedQuery.split(' ');
  return items
    .map((item, index) => ({
      item,
      index,
      rank: matchRank(item, normalizedQuery, queryWords),
    }))
    .filter(({ rank }) => rank >= 0)
    .sort((left, right) => (
      left.rank - right.rank
      || left.index - right.index
    ))
    .map(({ item }) => item);
};

